import PropTypes from 'prop-types';
import { Style } from '@/components/style';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as Location } from '@/assets/img/location.svg';
import { ReactComponent as LocationBlack } from '@/assets/img/location-black.svg';
import { ReactComponent as ArrowDown } from '@/assets/img/arrow_down_gray3.svg';
import { ReactComponent as ArrowDownAlert } from '@/assets/img/arrow_down_alert.svg';
import '../welcome.scss';

const { gray3Color, blackColor, alertColor } = new Style().getUiConfig();
function LocationSelector({
  locations,
  tradingLocation,
  setTradingLocation,
  showWarnMsg,
}) {
  return (
    <div
      className="position-relative"
      style={{ width: '100%', textAlign: 'right' }}
    >
      <button
        className="btn btn-lg location-selector"
        style={{
          border: `1px solid ${!showWarnMsg ? gray3Color : alertColor}`,
          color: `${!tradingLocation ? gray3Color : blackColor}`,
          width: '100%',
        }}
        type="button"
        data-testid="locationDropDownMenu"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center justify-content-start">
            {!tradingLocation ? (
              <Location className="me-2" />
            ) : (
              <LocationBlack className="me-2" />
            )}
            {!tradingLocation ? (
              <FormattedMessage id="location.selector.select.address" />
            ) : (
              tradingLocation
            )}
          </div>

          {showWarnMsg ? <ArrowDownAlert /> : <ArrowDown />}
        </div>
      </button>
      <ul
        style={{ width: '100%', border: '1px solid #8D8C8C' }}
        className="dropdown-menu takeout-list position-absolute"
        aria-labelledby="locationDropDownMenu"
      >
        {locations?.map((location) => (
          <li key={location} className="div-hover">
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ fontSize: '16px', height: '45px' }}
              onClick={() => {
                setTradingLocation(location);
              }}
            >
              {location}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

LocationSelector.defaultProps = {
  showWarnMsg: false,
};

LocationSelector.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.string).isRequired,
  setTradingLocation: PropTypes.func.isRequired,
  tradingLocation: PropTypes.string.isRequired,
  showWarnMsg: PropTypes.bool,
};

export default LocationSelector;
